import * as yup from 'yup';

export interface OneTimeVerificationSms {
  phoneNumber: string;
  verificationCode: string;
}

export interface OneTimeVerificationEmail {
  verificationCode: string;
}

export interface OneTimeVerificationRegister {
  dateOfBirth: string;
}

const validationMessages = {
  required: 'Required field',
  phoneNumber: 'Please enter a valid phone number',
  validDate: 'Enter a valid date of birth (MM/DD/YYYY)',
};

export const oneTimeVerificationSmsSchema = (formSubmitted: boolean) =>
  yup.object({
    phoneNumber: yup
      .string()
      .length(14, validationMessages.phoneNumber)
      .required(validationMessages.required),
    verificationCode: yup.string().when('phoneNumber', {
      is: () => formSubmitted,
      then: yup.string().required(validationMessages.required),
    }),
  });

export const oneTimeVerificationEmailSchema = yup.object({
  verificationCode: yup.string().required(validationMessages.required),
});

export const registerOneTimeVerificationCodeSchema = yup.object({
  dateOfBirth: yup
    .string()
    .required(validationMessages.required)
    .length(10, validationMessages.validDate)
    .test('isValidDate', validationMessages.validDate, (value) => {
      if (!value) return false;
      // Convert the value to a Date object
      const date = new Date(value);

      // Check if the date is a valid date
      if (isNaN(date.getTime())) return false;

      // Check if the date is more than 16 years ago
      const sixteenYearsAgo = new Date();
      sixteenYearsAgo.setFullYear(sixteenYearsAgo.getFullYear() - 16);

      return date < sixteenYearsAgo;
    }),
});
